<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("Aspect", 1) }} {{ $tc("Ratios", 1) }}
        </div>
        <!-- <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("region", 2) }}
          {{ $tc("incinematic") }}
        </div> -->
      </div>
      <div>
        <router-link variant="default" class="btn-blue" to="add-aspect-ratio">{{
          $tc("add")
        }}</router-link>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getAspectRatios"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>{{ $tc("Name", 1) }}</th>
          <th>{{ $tc("Aspect", 1) }} {{ $tc("Ratio", 1) }}</th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="AspectRatios.length > 0">
        <tr v-for="(item, key) in AspectRatios" :key="key">
          <td>{{ item.aspect_ratio_name }}</td>
          <td>{{ item.aspect_ratio }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.aspect_ratio_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.aspect_ratio_is_active ? 'active' : 'inactive'"
              />
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-aspect-ratio', item)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="AspectRatios.length == 0">
        <td>{{ errors.message }}</td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import MasterService from "@/services/MasterService";
import Regions from "@/helper/formJSONMaster/Regions";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Regions.Methods,
      AspectRatios: [],
      customErrors: {
        message: ""
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      searchValue: ""
    };
  },
  beforeMount() {
    this.getAspectRatios();
    this.getviewingnumber();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getAspectRatios();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAspectRatios();
      } else {
        this.currentPage = event;
        this.getAspectRatios();
      }
    },
    /* eslint-disable */
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { aspect_ratio_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: aspect_ratio_id
        }
      });
    },

    getAspectRatios: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue
      };
      this.AspectRatios = [];
      MasterService.GetAllAspectRatios(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data", data);
            if (
              data.Records &&
              data.Records.data &&
              data.Records.data.length > 0
            ) {
              this.AspectRatios = data.Records.data;
              this.AspectRatios.forEach(x => {
                x.aspect_ratio_is_active =
                  x.aspect_ratio_is_active === "Y" ? true : false;
              });
              if (data.Records.pagination && data.Records.pagination.total) {
                this.rows = data.Records.pagination.total;
                this.selectedvalue =
                  data.Records.pagination.total < 10
                    ? data.Records.pagination.total
                    : this.selectedvalue;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AspectRatiosComponent/ListAspectRatio.vue